/**
 * 这里组件主要用于 每个Item的描述
 * */

import GlobalContext from "@/context/GlobalContext";
import { useNavigator } from "@/utils/NetworkCheck";
import React, { useContext } from "react";
import { StatusDesc, StatusErrorDesc, ErrorCode, Status } from "../../type";
import "./index.less";
import { ResetErrorCode } from "@/components/Joyspace/types";
// 下载完成
export const SuccessDesc = (props: any) => {
  const { size } = props;
  return (
    <span className="download-desc">
      {StatusDesc.SUCCESS} {size}
    </span>
  );
};
// 正在下载/等待下载的描述
export const ProgressDesc = (props: any) => {
  const { size = "", progress = "" } = props;
  return (
    <span className="download-desc">
      {StatusDesc.PROGRESS}
      {progress}/{size}
    </span>
  );
};
// 取消/重试的描述
export const CancelDesc = () => {
  return <span className="download-desc">{StatusDesc.CANCEL}</span>;
};
// 错误描述
export const ErrorDesc = (props: any) => {
  const { status } = props;
  console.log(status, "statusstatusstatusstatusstatusstatus");
  switch (status) {
    case ErrorCode.FILE_DEL_ERROR:
    case ResetErrorCode.Delete:
      return <span className="download-desc">{StatusErrorDesc.FILE_DEL_ERROR}</span>;
    case ErrorCode.NETWORK_ERROR:
      return <span className="download-desc">{StatusErrorDesc.NETWORK_ERROR}</span>;
    case ErrorCode.NO_PERMISSION:
    case ResetErrorCode.noPermission:
      return <span className="download-desc">{StatusErrorDesc.NO_PERMISSION}</span>;
    case ErrorCode.PATH_NOT_EXIST:
      return <span className="download-desc">{StatusErrorDesc.PATH_NOT_EXIST}</span>;
    case ErrorCode.PRIVATENET_EGOV_FILE:
      return <span className="download-desc">{StatusErrorDesc.PRIVATENET_EGOV_FILE}</span>;
    case ErrorCode.FILE_EXPIRED:
      return <span className="download-desc">{StatusErrorDesc.FILE_EXPIRED}</span>;
    case ErrorCode.FILE_CHECK_PROCESS_ERROR:
      return <span className="download-desc">{StatusErrorDesc.FILE_CHECK_PROCESS_ERROR}</span>;
    case ErrorCode.FILE_CHECK_FAIL_ERROR:
      return <span className="download-desc">{StatusErrorDesc.FILE_CHECK_FAIL_ERROR}</span>;
    default:
      return <span className="download-desc">{StatusErrorDesc.ERROR}</span>;
  }
};

interface IProps {
  status: Status | ErrorCode;
  size: string;
  progress: string;
}

export const StatusDescComs = (props: IProps) => {
  const { status, size, progress } = props;
  const { onLine } = useContext(GlobalContext);
  // console.log(props, 'sadsadadadadasdad');
  if (
    (!onLine && (status === Status.WAITING || status === Status.PROGRESS)) ||
    status === Status.CANCEL
  ) {
    return <CancelDesc />;
  }
  if (status === Status.WAITING || status === Status.PROGRESS) {
    return <ProgressDesc size={size} progress={progress} />;
  }
  if (status === Status.SUCCESS) {
    return <SuccessDesc size={size} />;
  }
  return <ErrorDesc status={status} />;
};
